import React from 'react';

import {FirstAccess} from 'presentation/pages/public/first-access';

export const MakeFirstAccess: React.FC = () => <FirstAccess />;
